<p-toast position="top-right"></p-toast>

  <div class="spinner-container spinner-centered" *ngIf="loading">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="preview-label">Saving...</p>
</div>

<p-dialog [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [(visible)]="showConfirmCreation" [style]="{ width: '525px', height: '280px' }">
    <div class="confirm-dialog-header">Confirm Creation</div>
    <div class="confirm-dialog-content mt-5">Are you sure you want to create this item? Once submitted, it will be added to your records.</div>
    <div class="flex gap-3 mt-5 buttons">
        <button type="button" class="cancel-btn font-btn" (click)="showConfirmCreation = false">Cancel</button>
        <button type="button" class="save-btn font-btn" (click)="finish()">Save Item</button>
    </div>
</p-dialog>

<h2 class="pt-3 title" mat-dialog-title>
  {{modalTitle}}
</h2>

<h3 class="subtitle">
  Ensure your store information is accurate before saving.
</h3>

<mat-icon
  class="close-icon"
  aria-hidden="false"
  aria-label="close icon"
  iconPositionEnd
  mat-dialog-close
  >close</mat-icon
>

<mat-dialog-content>
        <mat-stepper [linear]="isLinear" #stepper (selectionChange)="onStepChange($event)">
    <!-- Step One -->
    <mat-step [stepControl]="stepOneForm">
      <form [formGroup]="stepOneForm" class="mt-2" id="create-store-form" (ngSubmit)="onStepOneSubmit()">
        <ng-template matStepLabel>Details</ng-template>

          <div class="flex">
              <div class="store-type-block">
                  <div class="labels">Store Type</div>
                  <mat-radio-group class="" formControlName="StoreType" (change)="changeStoreType($event)">
                      <mat-radio-button color="primary" [value]="1">Eats</mat-radio-button>
                      <mat-radio-button color="primary" [value]="2">Mart</mat-radio-button>
                  </mat-radio-group>
              </div>

              <mat-form-field appearance="fill" class="full-width p-2">
                  <mat-label>Street Address</mat-label>
                  <input
                          type="text"
                          matInput
                          formControlName="Address"
                          [matAutocomplete]="streetAuto"
                  />
                  <mat-autocomplete
                      #streetAuto="matAutocomplete"
                      (optionSelected)="onOptionSelected($event)"
                      [displayWith]="displayFn"
                  >
                      <mat-option
                              *ngFor="let option of filteredOptions$ | async"
                              [value]="option"
                      >
                          {{ option.description }}
                      </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="stepOneForm.get('Address')?.hasError('required')">
                      This field is required.
                  </mat-error>
                  <mat-error *ngIf="stepOneForm.get('Address')?.hasError('isDuplicate')">
                      This location already exists in your store list.
                  </mat-error>
                  <mat-error *ngIf="stepOneForm.get('Address')?.hasError('invalidAddress')">
                      Invalid Address.
                  </mat-error>
              </mat-form-field>
          </div>

        <div
          #mapContainer
          class="map"
          [ngStyle]="{ height: stepOneForm.get('Address')?.invalid ? '0' : '15rem' }"
        ></div>

        <mat-form-field *ngIf="stepOneForm.get('Address')?.valid" appearance="outline">
          <mat-label>Serviceable Area (KM Radius)</mat-label>
          <input matInput type="number" formControlName="Radius" />
          <mat-error *ngIf="stepOneForm.get('Radius')?.hasError('required')">
            This field is required.
          </mat-error>
        </mat-form-field>

        <div class="labels">Location Details</div>

        <mat-form-field appearance="fill" class="w-50 p-2">
          <mat-label>Brand</mat-label>
          <input matInput placeholder="" formControlName="brand" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-50 p-2">
          <mat-label>Store Name</mat-label>
          <input matInput placeholder="" formControlName="StoreName" required />
          <mat-error *ngIf="stepOneForm.get('StoreName')?.hasError('required')">
            Store name is required.
          </mat-error>
        </mat-form-field>

         <mat-form-field appearance="fill" class="w-50 p-2">
          <mat-label>Location Type</mat-label>
          <mat-select (selectionChange)="onLocationTypeSelected($event)"
            formControlName="locType"
            [placeholder]="'(ex: ' + locationTypeList[0].name + ')'"
          >
            <mat-option
              *ngFor="let type of locationTypeList"
              [value]="type.value"
              >{{ type.name }}</mat-option
            >
          </mat-select>
          <mat-error *ngIf="stepOneForm.get('locType')?.hasError('required')"
            >This field is required.</mat-error
          >
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-50 p-2">
          <mat-label>Additional Details</mat-label>
          <input matInput placeholder="" formControlName="addDetails" required />
          <mat-error *ngIf="stepOneForm.get('addDetails')?.hasError('required')">
            Additional details are required.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-50 p-2">
            <mat-label>City</mat-label>
            <input matInput placeholder="" formControlName="City" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-50 p-2">
            <mat-label>Postal Code</mat-label>
            <input matInput placeholder="" formControlName="PostalCode" />
        </mat-form-field>

        <div class="labels">Location Photo (not published)</div>
        <!-- Upload Section -->
        <ng-container *ngIf="!stepOneForm.get('ImageUrl')?.value; else filename">
          <div
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onFileDrop($event)"
            class="upload"
            [ngClass]="{
              'upload-error':
                stepOneForm.get('ImageUrl')?.invalid && stepOneForm.touched
            }"
          >
            <p class="upload__hint">Drop files here to upload</p>

            <input
              type="file"
              class="upload__file-input"
              (change)="onFileSelected($event)"
              #fileUpload
            />
            <button
              mat-button
              type="button"
              class="light-button"
              (click)="fileUpload.click()">
              Browse file
            </button>
          </div>

          <p class="upload-error-message">
            <ng-container *ngIf="locationPhotoFile?.hasError('filesize')">
              {{ locationPhotoFile?.errors?.['filesize'] }}
            </ng-container>
            <ng-container *ngIf="locationPhotoFile?.hasError('fileType')">
              {{ locationPhotoFile?.errors?.['fileType'] }}
            </ng-container>
          </p>
        </ng-container>
        <ng-template #filename>
          <div class="image-preview-container">
            <img
              [src]="stepOneForm.get('ImageUrl')?.value"
              alt="Location Photo Preview"
              class="image-preview"
              (error)="onImageError($event)"
            />
            <button
              mat-icon-button
              color="warn"
              (click)="removeLocationPhoto()"
              class="remove-photo-btn">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </ng-template>

        <div class="labels">Contact Information</div>

        <mat-form-field appearance="fill" class="w-50 p-2">
            <mat-label>Store Email Address</mat-label>
            <input matInput placeholder="Store Email Address" formControlName="StoreEmailAddress" required />
            <mat-error *ngIf="stepOneForm.get('StoreEmailAddress')?.hasError('required')">
                Store email address is required.
            </mat-error>
            <mat-error *ngIf="stepOneForm.get('StoreEmailAddress')?.touched && stepOneForm.get('StoreEmailAddress')?.hasError('email')">
                Please enter a valid email address.
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-50 p-2">
            <mat-label>Store Phone Number</mat-label>
            <input matInput placeholder="Store Phone Number" formControlName="StorePhoneNumber" required />
            <mat-error *ngIf="stepOneForm.get('StorePhoneNumber')?.hasError('required')">
                Store phone number is required.
            </mat-error>
            <mat-error *ngIf="stepOneForm.get('StorePhoneNumber')?.touched && stepOneForm.get('StorePhoneNumber')?.hasError('pattern')">
                Please enter a valid PH mobile number (e.g +639123456789).
            </mat-error>
        </mat-form-field>

        <p class="labrequired">
            Required form labels ends with an *
        </p>
      </form>
    </mat-step>

    <!-- Step Two -->
    <mat-step [stepControl]="stepTwoForm">
      <form [formGroup]="stepTwoForm">
        <ng-template matStepLabel>Products</ng-template>

        <div class="cp-upload-description-block">
          <div class="cp-upload-description-block__title" style="margin-bottom: 10px">
            Products
          </div>
          <div style="margin-bottom: 20px">
            Bulk Upload
          </div>
          <!-- List to upload -->
          <mat-chip-listbox>
            <mat-chip
              *ngFor="let uploadSelected of uploadedFiles; let i = index"
              color="primary"
              selected
              (removed)="removeUploadProductTemplate(i)"
            >
              {{ uploadSelected.name }}
              <button matChipRemove>
                <mat-icon>close</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-listbox>

            <!-- Upload button -->
            <div class="flex flex-row gap-2" style="height: 150px">
                <div matRipple (click)="triggerFileInput()" class="flex justify-content-center align-items-center upload-ripple">
                    <div class="flex flex-column">
                                    <span class="material-symbols-outlined flex align-items-center justify-content-center" style="font-size: 24px">
										upload
									</span>
                        <p class="flex align-items-center justify-content-center">Upload Xls</p>
                        <p class="upload-limits align-items-center justify-content-center">(only .xlsx up to 50MB)</p>
                    </div>
                </div>
                <div matRipple (click)="getProductsTemplate()" class="flex justify-content-center align-items-center download-ripple"
                >
                    <div class="flex flex-column align-items-center">
										<span class="material-symbols-outlined" style="font-size: 24px">
											download
										</span>
                        <p class="text-center p-1">Download Template</p>
                    </div>
                </div>
            </div>
          <!-- Hidden file input -->
          <input
            #hiddenFileInput
            id="idFileInput"
            type="file"
                            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            (change)="onMultipleFilesSelected($event)"
            hidden
          />
        </div>
      </form>
    </mat-step>

    <!-- Step Three -->
    <mat-step [stepControl]="stepThreeForm">
      <ng-template matStepLabel>Store Hours</ng-template>
      <mat-tab-group class="tab-group-bordered">
        <mat-tab label="Operation Hours">
          <div class="flex justify-content-between mt-3">
            <div class="special-hrs">Operation Hours</div>
            <button mat-flat-button color="primary" (click)="showModal()">
              Add Operation Hours
              <mat-icon matPrefix>add</mat-icon>
            </button>
          </div>
           <div class="flex gap-2 textcontent">
              <img src="/XpressApp/assets/images/tabs_warning.png" />
              <div>
                <p>Set your menu availability with ease using the timeline. Select the desired days and adjust blocks on the graph to set start and end times. Your changes are saved instantly, ensuring accurate availability information. Learn more.</p>
              </div>
            </div>
            <!-- Display multiple operating hours entries -->
            <div *ngFor="let entry of savedOperationHours; let i = index" class="picked-time-layout ml-2 mt-2 mb-1">
               <div class="flex justify-content-between flex-wrap w-full">
                 <div class="picked-time-header">
                   {{ entry.selectedDays.join(', ') }}
                 </div>
                 <div class="flex gap-2">
                   <button mat-button color="primary" (click)="editOperationHours(i)">
                     <mat-icon matPrefix>edit</mat-icon>
                     Edit
                   </button>
                   <button mat-button color="warn" (click)="removeOperationHours(i)" *ngIf="savedOperationHours.length > 1">
                     <mat-icon matPrefix>delete</mat-icon>
                     Remove
                   </button>
                 </div>
               </div>
               <div class="pick-time-sub-header">
                 Operating Days
               </div>
               
               <div class="picked-time-header">
                 <div *ngFor="let timeRange of entry.timeRanges; let j = index" class="time-range-display">
                   {{ formatTime(timeRange.hour, timeRange.minute, timeRange.period) }} - {{ formatTime(timeRange.endHour, timeRange.endMinute, timeRange.endPeriod) }}
                 </div>
               </div>
               <div class="pick-time-sub-header">
                 Store Hours
               </div>
             </div>

             <!-- Show empty state when no operation hours are set -->
             <div *ngIf="savedOperationHours.length === 0" class="flex align-items-center justify-content-center operationlogo">
               <img src="/XpressApp/assets/images/nooperationhrs.png" />
             </div>
        </mat-tab>
        <mat-tab label="Special Hours">
          <div class="flex justify-content-between mt-3">
            <div class="special-hrs">Special Hours</div>
            <button mat-flat-button color="primary" (click)="openAddSpecialHoursDialog()">
              Add Special Hours
              <mat-icon matPrefix>add</mat-icon>
            </button>
          </div>
          <div class="flex gap-2 textcontent">
            <img src="/XpressApp/assets/images/tabs_warning.png" />
            <div>
              <p>Set your menu availability with ease using the timeline. Select the desired days and adjust blocks on the graph to set start and end times. Your changes are saved instantly, ensuring accurate availability information. Learn more.</p>
            </div>
          </div>

          <!-- Display special hours entries -->
          <div
            *ngFor="let specialHour of saveSpecialHours; let i = index"
            class="picked-time-layout ml-2 mt-2 mb-1"
          >
            <div class="flex justify-content-between flex-wrap w-full">
              <div class="picked-time-header">
                {{
                  formatSpecialHoursDateRange(
                    specialHour.startDate,
                    specialHour.endDate
                  )
                }}
              </div>
              <div class="flex gap-2">
                <button mat-button color="primary" (click)="editSpecialHours(i)">
                  <mat-icon matPrefix>edit</mat-icon>
                  Edit
                </button>
                <button mat-button color="warn" (click)="removeSpecialHours(i)">
                  <mat-icon matPrefix>delete</mat-icon>
                  Remove
                </button>
              </div>
            </div>
            <div class="pick-time-sub-header">Date Range</div>

            <div
              class="picked-time-header"
              *ngIf="specialHour.availability && !specialHour.open24hrs"
            >
              <div
                *ngFor="let timeRange of specialHour.timeRanges; let j = index"
                class="time-range-display"
              >
                {{ formatTime(timeRange.hour, timeRange.minute, timeRange.period) }} -
                {{
                  formatTime(
                    timeRange.endHour,
                    timeRange.endMinute,
                    timeRange.endPeriod
                  )
                }}
              </div>
            </div>
            <div class="picked-time-header" *ngIf="specialHour.open24hrs">
              <div class="time-range-display">Open 24 Hours</div>
            </div>
            <div class="picked-time-header" *ngIf="!specialHour.availability">
              <div class="time-range-display">Closed</div>
            </div>
            <div class="pick-time-sub-header">Special Hours</div>

            <div class="picked-time-header" *ngIf="specialHour.description">
              <div class="time-range-display">{{ specialHour.description }}</div>
            </div>
            <div class="pick-time-sub-header" *ngIf="specialHour.description">
              Description
            </div>
          </div>

          <!-- Show empty state when no special hours are set -->
          <div
            *ngIf="saveSpecialHours.length === 0"
            class="operationlogo flex flex-column align-items-center justify-content-center gap-2"
          >
            <img src="/XpressApp/assets/images/noOperation.png" />
            <div class="flex flex-column align-items-center">
                <h5 class="text-center">No Special Hours Set</h5>
                <p class="textbanner text-center">There's nothing here yet. Add specific dates and times for holidays or temporary changes to your regular delivery schedule.</p>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Preparation Time">
          <div class="prep-time-title">Preparation Time</div>
          <div class="prep-time-card">
            <div class="flex justify-content-between flex-wrap w-full align-items-center mt-3">
									<div class="prep-time-value">{{ prepTimeValue }}</div>
                <button mat-button color="primary" (click)="onEditPreparationTime()">
                  <mat-icon matPrefix>edit</mat-icon>
                  Edit
                </button>
            </div>
            <div class="prep-time-sub">Preparation Time</div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-step>

      <!-- Step Four -->
      <mat-step [stepControl]="stepFourForm">
          <form [formGroup]="stepFourForm" id="create-store-form" (ngSubmit)="onNextStep()">
              <ng-template matStepLabel>Settings</ng-template>

              <div class="labels">Assigned Merchant</div>

              <mat-form-field appearance="fill" class="w-50 p-2">
                  <mat-label>Select Merchant</mat-label>
                  <mat-select (selectionChange)="onMerchantSelected($event)"
                              formControlName="MerchantId"
                              [placeholder]="'Please Select Merchant'"
                  >
                      <mat-option
                              *ngFor="let merchant of merchantsList"
                              [value]="merchant.Id"
                      >{{ merchant.Name }}</mat-option
                      >
                  </mat-select>
                  <mat-error *ngIf="stepFourForm.get('MerchantId')?.hasError('required')"
                  >Merchant is required.</mat-error
                  >
              </mat-form-field>

              <div class="labels">Settings</div>

              <mat-form-field appearance="fill" class="w-50 p-2 percent-field">
                  <mat-label>Commission</mat-label>
                  <input matInput formControlName="Commission" required (focusout)="formatValue($event, 'Commission')"
                         (input)="onInput($event)" [value]="commissionDisplayValue" />
                  <mat-error *ngIf="stepFourForm.get('Commission')?.hasError('required')">
                      Commission is required.
                  </mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill" class="w-50 p-2">
                  <mat-label>Promo Advertising Budget</mat-label>
<!--                  <div class="peso-sign" matPrefix>₱</div>-->
                  <input matInput formControlName="PromoAdvertisingBudget" required
                          />
                  <mat-error *ngIf="stepFourForm.get('PromoAdvertisingBudget')?.hasError('required')">
                      Promo Advertising Budget is required.
                  </mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill" class="w-50 p-2">
                  <mat-label class="ml-3">Minimum Order Amount</mat-label>
                  <div class="peso-sign" matPrefix>₱</div>
                  <input class="ml-5" matInput formControlName="MinimalOrderAmount" required (focusout)="formatValue($event, 'MinimalOrderAmount')"
                         (input)="onInput($event)" [value]="amountDisplayValue" />
                  <mat-error *ngIf="stepFourForm.get('MinimalOrderAmount')?.hasError('required')">
                      Minimum Order Amount is required.
                  </mat-error>
              </mat-form-field>

              <mat-form-field appearance="fill" class="w-50 p-2">
                  <mat-label class="ml-3">Minimum Order Fee</mat-label>
                  <div class="peso-sign" matPrefix>₱</div>
                  <input class="ml-5"matInput formControlName="MinimalOrderFee" required (focusout)="formatValue($event, 'MinimalOrderFee')"
                         (input)="onInput($event)" [value]="feeDisplayValue" />
                  <mat-error *ngIf="stepFourForm.get('MinimalOrderFee')?.hasError('required')">
                      Minimum Order Fee is required.
                  </mat-error>
              </mat-form-field>
          </form>
      </mat-step>

      <!-- Step Five -->
      <mat-step [stepControl]="stepFiveForm">
          <form [formGroup]="stepFiveForm" id="create-store-form" (ngSubmit)="onNextStep()">
              <ng-template matStepLabel>Preview</ng-template>

              <mat-accordion [multi]="true" class="preview-accordion">
                  <div class="preview-warn-header">
                      <img src="../Content/xpress-app/images/svg/preview-store-warn.svg" />
                      <div>Please Review Carefully: This is a preview of the details you have entered. Double-check all information for accuracy before saving</div>
                  </div>

                  <mat-expansion-panel class="preview-panel" (opened)="showDetailsPreview = true" (closed)="showDetailsPreview = false">
                      <mat-expansion-panel-header class="preview-header">
                          <mat-panel-title>
                              Details
                          </mat-panel-title>
                      </mat-expansion-panel-header>
                      <mat-divider></mat-divider>

                      <div class="flex">
                          <div class="w-50">
                              <div class="preview-label mt-5">Store Name:</div>
                              <div class="preview-text-field ml-3 mt-2">{{createStoreDto.Name}}</div>

                              <div class="preview-label mt-5">Store Address:</div>
                              <div class="preview-text-field ml-3 mt-2">{{createStoreDto.Address}}</div>

                              <div class="preview-label ml-3 mt-5">Store Photos:</div>
                              <img *ngIf="createStoreDto.ImageUrl" class="preview-photo ml-3 mt-2" src="{{createStoreDto.ImageUrl}}">
                          </div>
                                <div class="w-50">
                                    <div class="preview-label mt-5">Location Details</div>
                                    <div class="ml-3 mt-3">
                                        <div class="preview-label mt-3">Brand</div>
                                        <div class="preview-text-field ml-3 mt-2">{{createStoreDto.Brand}}</div>

                                        <div class="preview-label mt-3">Location Name</div>
                                        <div class="preview-text-field ml-3 mt-2">{{createStoreDto.City}}</div>

                                        <div class="preview-label mt-3">Location Type</div>
                                        <div class="preview-text-field ml-3 mt-2">{{locationName}}</div>

                                        <div class="preview-label mt-3">Serviceable Area (KM Radius)</div>
                                        <div class="preview-text-field ml-3 mt-2">{{createStoreDto.ServiceableAreaRadius}}</div>

                                        <div class="preview-label mt-3">Postal Code</div>
                                        <div class="preview-text-field ml-3 mt-2">{{createStoreDto.PostalCode}}</div>

                                        <div class="preview-label mt-3">Additional Details</div>
                                        <div class="preview-text-field ml-3 mt-2">{{createStoreDto.AddressDetails}}</div>
                                    </div>

                                    <div class="preview-label mt-5">Contact Information</div>
                                    <div class="ml-3 mt-3">
                                        <div class="preview-label mt-3">Store Email Address</div>
                                        <div class="preview-text-field ml-3 mt-2">{{createStoreDto.Email}}</div>

                                        <div class="preview-label mt-3">Phone Number</div>
                                        <div class="preview-text-field ml-3 mt-2">{{createStoreDto.Phone}}</div>
                                    </div>
                                </div>
                      </div>
                  </mat-expansion-panel>

                  <mat-expansion-panel class="preview-panel" (opened)="showProductsPreview = true" (closed)="showProductsPreview = false">
                      <mat-expansion-panel-header class="preview-header">
                          <mat-panel-title>
                              Products
                          </mat-panel-title>
                      </mat-expansion-panel-header>

                      <mat-divider></mat-divider>
                      <div class="preview-label mt-5">Inventory List:</div>

                      <div class="preview-text-field underline ml-3 mt-2"
                           *ngFor="let fileName of filesNames">{{fileName}}
                      </div>
                  </mat-expansion-panel>

                  <mat-expansion-panel class="preview-panel" (opened)="showStoreHoursPreview = true" (closed)="showStoreHoursPreview = false">
                      <mat-expansion-panel-header class="preview-header">
                          <mat-panel-title>
                              Store Hours
                          </mat-panel-title>
                      </mat-expansion-panel-header>

                      <mat-divider></mat-divider>
                      <div class="preview-label mt-5">Operation Hours:</div>
                      <ng-container *ngFor="let hour of previewOperationHours">
                          <div class="preview-text-field ml-3 mt-2">{{hour}}</div>
                      </ng-container>
                  </mat-expansion-panel>

                  <mat-expansion-panel class="preview-panel" (opened)="showSettingsPreview = true" (closed)="showSettingsPreview = false">
                      <mat-expansion-panel-header class="preview-header">
                          <mat-panel-title>
                              Settings
                          </mat-panel-title>
                      </mat-expansion-panel-header>

                      <mat-divider></mat-divider>
                            <div class="preview-label mt-5">Assigned Merchant</div>
                     <div class="preview-text-field ml-3 mt-2">{{merchantName}}</div>
                            <div class="preview-label mt-5">Store Type</div>
                      <div class="preview-text-field ml-3 mt-2">{{storeTypeText}}</div>
                            <div class="preview-label mt-5">Commission</div>
                      <div class="preview-text-field ml-3 mt-2">{{createStoreDto.Commission}}&nbsp;%</div>
                            <div class="preview-label mt-5">Minimum Order Amount</div>
                      <div class="preview-text-field ml-3 mt-2">₱&nbsp;{{createStoreDto.MinimalOrderAmount}}</div>
                            <div class="preview-label mt-5">Minimum Order Fee</div>
                      <div class="preview-text-field ml-3 mt-2">₱&nbsp;{{createStoreDto.MinimalOrderFee}}</div>
                  </mat-expansion-panel>

              </mat-accordion>
          </form>
      </mat-step>
  </mat-stepper>
</mat-dialog-content>

<mat-dialog-actions class="pr-4 pb-4" align="end">
  <button mat-button mat-dialog-close *ngIf="isStepperReady && stepper.selectedIndex === 0">
    Cancel
  </button>
  <button class="back-btn" (click)="goBack()" mat-button *ngIf="isStepperReady && stepper.selectedIndex > 0">
    Back
  </button>
  <button *ngIf="stepper.selectedIndex !== stepper.steps.length - 1" (click)="onNextStep()" mat-flat-button [disabled]="
            (this.stepper.selectedIndex === 0 && this.stepOneForm.invalid) ||
            (this.stepper.selectedIndex === 1 && (this.stepTwoForm.invalid || !productFileValid)) ||
            (this.stepper.selectedIndex === 3 && this.stepFourForm.invalid)">
    Next
    <mat-icon iconPositionEnd>arrow_forward</mat-icon>
  </button>
  <button mat-flat-button color="primary" *ngIf="isStepperReady && stepper.selectedIndex === stepper.steps.length - 1" (click)="showConfirmCreation = true"
          [disabled]="stepper.selectedIndex === stepper.steps.length - 1 && stepFourForm.invalid">
    Submit
  </button>
</mat-dialog-actions>
